import { render } from "./SiteFooter.vue?vue&type=template&id=eeb08f64&scoped=true"
const script = {}

import "./SiteFooter.vue?vue&type=style&index=0&id=eeb08f64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eeb08f64"]])

export default __exports__